import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/misc/talon-banner.png")